export default __webpack_public_path__ + "static/real-carousel-82ac14be85969d8a7270d8899455b84d.gif";